import axios from "axios";
// import store from './../index'

export default {
    state: {
        search: {
            fullName: "",
            // точный отбор одного товара (переход к SKU из строки заказа); сбрасывается при ручном вводе в поиск
            goodsId: null,
            beInThePrices: false,
            advanced: {
                INN: "",
                brand: "",
                ATC: "",
                producer: "",
                show: false
            }
        },
        searchResultGoodsIds: []
    },
    getters: {
        GOODS_SEARCH: state => {
            return state.search;
        },
        GOODS_SEARCH_RESULT_IDS: state => {
            return state.searchResultGoodsIds;
        },
    },
    mutations: {
        SET_GOODS_SEARCH: (state, payload) => {
            state.search = payload;
        },
        SET_GOODS_SEARCH_RESULT_IDS: (state, payload) => {
            state.searchResultGoodsIds = payload;
        },
    },
    actions: {
        ALL_GOODS_SEARCH_PAGING: (commit, payload) => {
            return new Promise((resolve, reject) => {
                axios
                    .post(`/Goods/GetAllSearchPagingAsync`, payload)
                    .then(({
                        data,
                        status
                    }) => {
                        if (status === 200) {
                            resolve(data);
                        }
                    })
                    .catch(error => {
                        reject(error);
                    })

            });

        },
        SPELLING_CORRECT_GOOGLE: (commit, payload) => {
            return new Promise((resolve, reject) => {
                axios
                    .post(`/Goods/SpellingCorrectGoogle`, payload)
                    .then(({
                        data,
                        status
                    }) => {
                        if (status === 200) {
                            resolve(data);
                        }
                    })
                    .catch(error => {
                        reject(error);
                    })

            });

        },
        CSE_TOKEN:(commit, payload) => {
            return new Promise((resolve, reject) => {
                axios
                    .get(`/Goods/GetCseTokenGoogle`, payload)
                    .then(({
                        data,
                        status
                    }) => {
                        if (status === 200) {
                            resolve(data);
                        }
                    })
                    .catch(error => {
                        reject(error);
                    })

            });

        },
    }
};